/**
 * Created by vladislav on 13.04.2022
 */

const ShipView = function (ship, unitView) {
    this.ship = ship;
    this.unitView = unitView;

    this.restoreState();
};

ShipView.prototype.restoreState = function () {
    const mission = this.ship.getMission();

    if (cleverapps.gameModes.hideGuideAndProgress || !(mission && mission.getTimeLeft())) {
        this.removeTimer();
    } else {
        this.createTimer();
    }
};

ShipView.prototype.onCustomSpawn = function (delay) {
    this.unitView.sprite.stopAllActions();
    this.unitView.sprite.setVisible(false);

    const prizeView = this.unitView.getAdditionalView("prize");
    if (prizeView) {
        prizeView.hide();
    }

    this.spawnAction = this.unitView.sprite.runAction(new cc.Sequence(
        new cc.DelayTime(delay || 0),
        new cc.Show(),
        new cc.CallFunc(this.restoreState.bind(this)),
        cleverapps.effects.fireAction("merge.ship.spawn"),
        new cc.CallFunc(() => {
            this.unitView.sprite.setAnimationAndIdleAfter("spawn", "idle");
        })
    ));
};

ShipView.prototype.createTimer = function () {
    const mission = this.ship.getMission();
    const styles = cleverapps.styles.ShipView;
    const timer = new ComponentTimer(new cleverapps.CountDown(mission.getTimeLeft()), cleverapps.parseInterval(mission.duration), {
        barType: ScaledProgressBar.Types.blue
    });
    timer.setAlignment(styles.timer);
    this.unitView.createAdditionalView("timer", timer);
};

ShipView.prototype.clearAnimations = function () {
    if (this.spawnAction) {
        if (!this.spawnAction.isDone()) {
            this.unitView.stopAction(this.spawnAction);
        }

        delete this.spawnAction;
    }
};

ShipView.prototype.removeTimer = function () {
    this.unitView.removeAdditionalView("timer");
};

cleverapps.styles.ShipView = {
    timer: {
        x: { align: "center" },
        y: { align: "center", dy: -100 }
    }
};